const metaEl = document.querySelector('meta[name=token]')
const token = process.env.NODE_ENV === 'production' && metaEl ? metaEl.content : ''
export default {
  token,
  userInfo: {},
  allPermissions: [],
  routes: {},
  /**
   * 有访问权限的url数组
   */
  permissions: [],
  /**
   * 有操作权限的prop数组
   */
  operateAuth: [],
  cached: [],
  businessTypes: [], // 业务类型数组
  childTaskTypes: [], // 子任务类型数组
  abnormalTypes: [] // 异常运营类型
}
